import { Dialog } from '@busybusy/webapp-react-ui';
import { CloseIcon } from 'assets/icons';
import classNames from 'classnames';
import IconButton from 'components/foundation/buttons/IconButton/IconButton';
import { ClassName } from 'types/ClassName';
import { t } from 'utils/localize';
import './ReferralDialog.scss';
import ReferralForm from './ReferralForm/ReferralForm';

export interface IReferralDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmitted: () => void;
  className?: ClassName;
}

const ReferralDialog = ({ isOpen, onClose, onSubmitted, className }: IReferralDialogProps) => (
  <Dialog isOpen={isOpen} onClose={onClose} size="full" hasDismiss={false}>
    <div className={classNames('referral-dialog', className)}>
      <IconButton className="referral-dialog-close" svg={CloseIcon} onClick={onClose} aria-label={t('Close')} />
      <ReferralForm onSubmitted={onSubmitted} />
    </div>
  </Dialog>
);

export default ReferralDialog;
